import "./App.css";
import React from "react";
import { Routes, Route } from "react-router-dom";
import Formulario from "./components/formulario/Formulario";
import Navbar from "./components/navbar/Navbar";
import Login from "./pages/login/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import Footer from "./components/footer/Footer";
import SolicitudServicio from "./pages/solicitud/SolicitudServicio";
import EstadoCliente from "./components/estadoCliente/EstadoCliente";
import PanelComercial from "./pages/panel/PanelComercial";
import MisVentas from "./pages/misVentas/MisVentas";
import NotFound from "./pages/notFound/NotFound";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="formulario" element={<Formulario />} />
        <Route path="solicitud-servicio" element={<SolicitudServicio />} />
        <Route path="estado-cliente" element={<EstadoCliente />} />
        <Route path="mis-ventas" element={<MisVentas />} />
        <Route path="panel" element={<PanelComercial />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
